import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <SEO title="Not Found — Tech Alpha SSL" description="Page not found." />
      <section className="pt-24 pb-24">
        <div className="container-page max-w-xl text-center">
          <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-[#1565FF]/10 text-[#1565FF] dark:bg-white/5 dark:text-[#4FC3F7]">
            <AlertTriangle className="h-8 w-8" />
          </div>
          <h1 className="mt-6 text-6xl font-semibold tracking-tighter">404</h1>
          <p className="mt-2 text-muted-foreground">This page has moved, been renamed, or never existed.</p>
          <div className="mt-8 flex justify-center gap-3">
            <Link to="/" className="btn-primary" data-testid="nf-home">Back to home</Link>
            <Link to="/contact" className="btn-ghost" data-testid="nf-contact">Contact us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
